// extracted by mini-css-extract-plugin
module.exports = {"c-new-on-cian-title":"_025a50318d--c-new-on-cian-title--3ntX0","c-new-on-cian-link-item":"_025a50318d--c-new-on-cian-link-item--5b4z1"};